export enum InterviewsStatus {
    Pending = 'Pending',
    Overdue = 'Overdue',
    Submitted = 'Submitted',
}
